import { AxiosError } from 'axios';
import { ErrorBag } from '@client/core/exception/error-bag';
import { HttpErrorResponse, HttpException } from '@client/core/exception/http-exception';
import HttpStatusCode from '@client/core/http/status-codes';

export interface HttpErrorResponseWithValidationErrors extends HttpErrorResponse {
  errors: Record<string, string[]>;
}

/**
 * An HTTP Response that resulted from a validation Exception thrown by our
 * backend validation code.
 */
export class ValidationException extends HttpException {
  readonly errors: ErrorBag;

  constructor(error: AxiosError<HttpErrorResponseWithValidationErrors>) {
    super(error);

    this.errors = new ErrorBag(error.response.data.errors || {});
  }

  /**
   * Whether the given value is an HTTP Exception that resulted from
   * validation failures thrown by our backend validation code.
   */
  public static isValidationException(e: ValidationException | any): e is ValidationException {
    return e && (e as ValidationException).statusCode === HttpStatusCode.UNPROCESSABLE_ENTITY;
  }
}
